import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWizardIntro = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 319 73",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("path", {
		d: "M130.667 0h47.573a1.6 1.6 0 0 1 1.412.847l11.946 22.4a1.6 1.6 0 0 1 0 1.506l-11.946 22.4a1.6 1.6 0 0 1-1.412.847h-47.573a1.6 1.6 0 0 1-1.412-2.353l11.143-20.894a1.6 1.6 0 0 0 0-1.506L129.255 2.353A1.6 1.6 0 0 1 130.667 0z",
		id: "b"
	}), /* @__PURE__ */ _jsxs("filter", {
		x: "-21.1%",
		y: "-26%",
		width: "142.2%",
		height: "204.2%",
		filterUnits: "objectBoundingBox",
		id: "a",
		children: [
			/* @__PURE__ */ _jsx("feOffset", {
				dy: 24,
				in: "SourceAlpha",
				result: "shadowOffsetOuter1"
			}),
			/* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: .5,
				in: "shadowOffsetOuter1",
				result: "shadowBlurOuter1"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
				in: "shadowBlurOuter1"
			})
		]
	})] }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M1.667 24H49.24a1.6 1.6 0 0 1 1.412.847l11.946 22.4a1.6 1.6 0 0 1 0 1.506l-11.946 22.4A1.6 1.6 0 0 1 49.24 72H1.667a1.6 1.6 0 0 1-1.412-2.353l11.143-20.894a1.6 1.6 0 0 0 0-1.506L.255 26.353A1.6 1.6 0 0 1 1.667 24zM65.667 24h47.573a1.6 1.6 0 0 1 1.412.847l11.946 22.4a1.6 1.6 0 0 1 0 1.506l-11.946 22.4a1.6 1.6 0 0 1-1.412.847H65.667a1.6 1.6 0 0 1-1.412-2.353l11.143-20.894a1.6 1.6 0 0 0 0-1.506L64.255 26.353A1.6 1.6 0 0 1 65.667 24z",
				fill: "#FFF",
				opacity: .4
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(-1)",
				children: [/* @__PURE__ */ _jsx("use", {
					fill: "#000",
					filter: "url(#a)",
					xlinkHref: "#b"
				}), /* @__PURE__ */ _jsx("use", {
					fill: "#FFF",
					xlinkHref: "#b"
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193.667 24h47.573a1.6 1.6 0 0 1 1.412.847l11.946 22.4a1.6 1.6 0 0 1 0 1.506l-11.946 22.4a1.6 1.6 0 0 1-1.412.847h-47.573a1.6 1.6 0 0 1-1.412-2.353l11.143-20.894a1.6 1.6 0 0 0 0-1.506l-11.143-20.894A1.6 1.6 0 0 1 193.667 24zM257.667 24h47.573a1.6 1.6 0 0 1 1.412.847l11.946 22.4a1.6 1.6 0 0 1 0 1.506l-11.946 22.4a1.6 1.6 0 0 1-1.412.847h-47.573a1.6 1.6 0 0 1-1.412-2.353l11.143-20.894a1.6 1.6 0 0 0 0-1.506l-11.143-20.894A1.6 1.6 0 0 1 257.667 24z",
				fill: "#FFF",
				opacity: .4
			})
		]
	})]
});
export default SvgWizardIntro;
